import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { useSnackbar } from 'notistack'

interface IProps {
  buttonKey: string | number
}

const SnackbarNotificationCloseButton = (props: IProps) => {
  const { buttonKey } = props

  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton onClick={() => closeSnackbar(buttonKey)} aria-label="Close notification">
      <CloseIcon fontSize="small" sx={{ color: 'white' }} />
    </IconButton>
  )
}

export default SnackbarNotificationCloseButton
